
import { gql } from "graphql-tag";
import { interestAllFields } from "utils/graphql";

export const QUERY_FORM_METADATA = gql`
query formMetaData($interestListID: ID!, $interestID: ID!) {
  interest(id: $interestID) {
    ${interestAllFields}
  }

  applicationFormMetadata(interestListId: $interestListID, source: APP) {
    interestListName
    schema {
      name
      label
      options {
        label
        value
      }
    }
  }
}
`;

export const UPDATE_INTEREST_DATA = gql`
mutation interestUpdateContainer($interestID: String!, $data: InterestInput!) {
  clientUpdateCompletedInterest(id: $interestID, update_data: $data) {
    ${interestAllFields}
  }
}
`;
